import { Portals } from '@backoffice-frontend/common'

export const MobileFilters = () => {
  return <div id={Portals.HeaderFilters} />
}
